<script setup lang="ts">
import { useAttrs } from 'vue';
defineOptions({ inheritAttrs: false, name: 'EGS_Toolbar' });
const attrs = useAttrs();
</script>
<template>
	<div v-bind="attrs" :class="['flex flex-wrap items-center justify-between gap-3 rounded-lg border border-surface bg-[var(--egs-content-background)] p-3', attrs['class']]" role="toolbar">
		<div class="flex flex-wrap items-center gap-2"><slot name="start" /></div>
		<div v-if="$slots['center']" class="flex flex-wrap items-center gap-2"><slot name="center" /></div>
		<div class="ml-auto flex flex-wrap items-center gap-2"><slot name="end" /></div>
	</div>
</template>
